
export const types_invoice:any = [
    {id : "invoice", name : "invoice", text : "Facture"},
    {id : "credit-note", name : "credit-note", text : "Avoir"}
]

export const credit_note_style = {
    color : "#d80303!important",
    fontWeight : "bold!important" 
}